/**
 * Scope filter params shared across search APIs.
 * All fields are optional — callers pass only what applies to their resource.
 */
export interface ScopeFilterParams {
  siteId?: string;
  siteIds?: string[];
  spaceId?: string;
  spaceIds?: string[];
}

/**
 * Append scope filter fields (siteId / siteIds / spaceId / spaceIds) onto a
 * mutable request-body object, omitting fields that are absent or empty arrays.
 *
 * Designed to be called inside any resource-level `toSearchBody` helper so the
 * scope-forwarding logic does not need to be duplicated per resource type.
 *
 * @example
 * const body: Record<string, unknown> = {};
 * applyScopeFiltersToBody(body, { siteId: 'abc', spaceIds: ['x', 'y'] });
 * // body => { siteId: 'abc', spaceIds: ['x', 'y'] }
 */
export function applyScopeFiltersToBody(body: Record<string, unknown>, params: ScopeFilterParams): void {
  if (params.siteId) body['siteId'] = params.siteId;
  if (params.siteIds && params.siteIds.length > 0) body['siteIds'] = params.siteIds;
  if (params.spaceId) body['spaceId'] = params.spaceId;
  if (params.spaceIds && params.spaceIds.length > 0) body['spaceIds'] = params.spaceIds;
}

/** Sets `body[key]` to `values`, omitting it when `values` is absent or empty. */
export function setArrayFilter(body: Record<string, unknown>, key: string, values: unknown[] | undefined): void {
  if (values && values.length > 0) body[key] = values;
}
